import Promise from 'bluebird';
import _ from 'lodash';
import store from '../../../store';
import { OVERVIEW_PANEL_GET_CURRENT, OVERVIEW_PANEL_IS_VISIBLE } from '../../../store/modules/overview-panel/types';

import worldMap from '../../core/map';
import templates from '../../core/templates';
import ColorBrewer from '../../core/tools/colorbrewer';
import ColorFlatUI from '../../core/tools/colorflatui';
import environment from '../../environment';
import Leaflet, { CustomLegendLayer } from '../Leaflet';
import { LocaleTypeEnum } from '../../../enuns/localeType.enum';
import translate from '../../core/tools/translate';
import filters from '../../core/filters';
import { ThemeValuesEnum } from '../../../enuns/AfterSales/themeValues.enum';

const LayerControls = (name) => require('../../controls').get(name);
const get = (name, currentMap = worldMap.getCurrent()) => {
    return require('../index').default.get(name, currentMap);
};

let layerLegend;

class AreaSharedAfterSalesLayer {
    constructor(currentMap, options) {
        const mapId = currentMap._id;

        const onSuccess = (featureCollection) => {
            return new Promise((resolve) => {

                if (LayerControls(options.name).getTypeValue() === LocaleTypeEnum.SetorCensitarioNeocorp) {
                    featureCollection.features.forEach(f => f.properties.disabled = true);
                }

                const themeId = (() => {
                    try {
                        return Number(LayerControls(options.name).getThemeValue(mapId));
                    } catch (err) {
                        return 0;
                    }
                })();

                if (themeId > 0) {
                    LayerControls(options.name).colorize(featureCollection, get(options.name, currentMap)).then((fc) => {
                        resolve(fc);
                    });
                } else {
                    resolve(featureCollection);
                }
            });
        };

        const onComplete = async () => {
            const controls = LayerControls(options.name).getControls();
            const themeValue = LayerControls(options.name).getThemeValue();

            if (layerLegend) {
                layerLegend.remove();
            }

            LayerControls(options.name).show({
                show: false,
                refresh: true
            });

            LayerControls(options.name)._applyManualColors(get(options.name, currentMap));

            if (
                store.getters[OVERVIEW_PANEL_GET_CURRENT] === options.name &&
                store.getters[OVERVIEW_PANEL_IS_VISIBLE] &&
                controls.button.overview.enable
            ) {
                LayerControls(options.name).toggleOverview();
            }

            if ((controls.checkbox.tagPgts || {}).status && themeValue !== ThemeValuesEnum.PGTS) {
                const layer = get(options.name, currentMap);
                const visibleTags = LayerControls(options.name)._getLayerTag();

                layer.setOptions({
                    tag: visibleTags
                });

                const features = layer.toGeoJSON().features;
                const pgtsValues = features.map(f => f.properties.Pgts);

                if (!pgtsValues.length) return;

                const items = features
                    .filter(f => Number(f.properties.Pgts) > 0)
                    .map(f => ({
                        text: `${f.properties.Nome} - ${f.properties.Pgts}`
                    }));
                const id = LayerControls(options.name).getIdMap();
                const filterData = filters.get(`filter-${_.kebabCase(options.name)}-${LayerControls(options.name).getThemeValue()}`, id);
                const nameOfLegend = `PGTS - ${getFormattedName(filterData)}`;

                layerLegend = new CustomLegendLayer({
                    map: currentMap,
                    title: `${nameOfLegend}`,
                    type: 'polygon',
                    items
                });
            }

            if (themeValue === ThemeValuesEnum.PGTS || themeValue === ThemeValuesEnum.MotorcyclePartsAndWorkshop) {
                onRemove();
            }
        };

        const getFormattedName = (data) => {
            const pgtsTypeList = environment.get('CONFIG.FILTERS.PGTS');
            if (!Array.isArray(pgtsTypeList) || !data.pgtsType || !Array.isArray(data.pgtsType.text)) {
                return `${translate('Common.All')}`;
            }

            const allPgtsTexts = pgtsTypeList.map(item => item.nome);
            const selectedTexts = data.pgtsType.text;

            const hasAll = allPgtsTexts.every(type => selectedTexts.includes(type));

            if (hasAll) {
                return `${translate('Common.All')}`;
            }

            if (selectedTexts.length === 1) {
                return selectedTexts[0];
            }

            return selectedTexts.slice(0, -1).join(", ") + " e " + selectedTexts.slice(-1)[0];
        };

        const onRemove = () => {
            if (layerLegend instanceof CustomLegendLayer) {
                layerLegend.remove();
                layerLegend = null;
            }
        };

        const layer = new Leaflet.D3Layer();
        layer.setOptions({
            map: currentMap,
            remote: {
                url: `${environment.get('API_HOST')}/aftersales/locales/areas`,
                params: {
                    locationType: options.fncIdLayerType
                        ? options.fncIdLayerType()
                        : environment.get('TYPE.AUTO')
                }
            },
            cache: true,
            filter: {
                location: true
            },
            scaleRange: new Leaflet.ZoomLevel(layer, {
                id: environment.get('TYPE.AUTO'),
                type: options.name,
                property: 'locationType'
            }),
            showAll: false,
            expandView: 0.5,
            autofocus: false,
            uniqueField: 'Id',
            sort: 'Nome',
            below: true,
            dblclick: options.onClick,
            done: onComplete,
            success: onSuccess,
            remove: onRemove,
            label: {
                template(properties) {
                    return templates('map-layer-areas-label', properties);
                },
                options: {
                    offset: [12, -40],
                    direction: 'left'
                }
            },
            value: 'Total',
            symbology: {
                type: 'choropleth',
                theme: ColorBrewer.OrRd[9],
                style: {
                    highlight: true,
                    lineJoin: 'round',
                    color: ColorFlatUI.wet_asphalt[1][0],
                    fillColor: 'rgba(0,0,0,0.1)',
                    fillOpacity: 0.2,
                    opacity: 1,
                    weight: 1
                }
            },
            manualPaints: LayerControls(options.name)._manualPaints,
        });

        return layer;
    }
}

export default AreaSharedAfterSalesLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/AfterSales/AreaSharedAfterSalesLayer.js